import type { Action, PayloadAction } from "@reduxjs/toolkit";
import * as actions from "./actions";
import type { ISessionInfo } from "./models";

export interface ISessionState {
  sessionInfo: ISessionInfo;
}

const initialState: ISessionState = {
  sessionInfo: {
    id: "",
    isGuest: false,
    timeout: 0,
    uid: "",
  },
};

export default function sessionReducer(
  state: ISessionState,
  action: Action,
): ISessionState | { sessionInfo: actions.IUpdateSessionInfoPayload } {
  if (typeof state === "undefined") {
    return initialState;
  }
  switch (action.type) {
    case actions.UPDATE_SESSION_INFO: {
      const sessionInfo = (
        action as PayloadAction<actions.IUpdateSessionInfoPayload>
      ).payload;
      return { ...state, sessionInfo };
    }
    default:
      return state;
  }
}
